import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { hasAnyRole, useAuth } from "./AuthProvider";

/*
 * Guards an admin page. Not signed in: off to the sign-in page, which returns
 * here afterwards. Signed in without the role: says so. The API checks the
 * role again on every call; this only keeps people off screens that would fail.
 */
export default function RequireRole({ roles = ["admin", "editor"], children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!hasAnyRole(user, roles)) {
    return (
      <div className="container admin">
        <h2>Not available</h2>
        <p>Your account does not have access to this page.</p>
        <p>
          <Link to="/admin">Back to the admin area</Link>
        </p>
      </div>
    );
  }

  return children;
}
